const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/defs/loginDefs.ts';
/**
 * Login state
 */
export const LoginState = {
    INITIAL: 'initial',
    SENDING_SMS_FROM_INVITATION: 'sending-sms-from-invitation',
    SMS_SENT: 'sms-sent',
    SEND_SMS_FAILED: 'send-sms-failed',
    VERIFYING_SMSCODE: 'verifying-smscode',
    VERIFY_SMSCODE_FAILED: 'verify-smscode-failed',
    GOT_TOKEN: 'got-token',
    REFRESHING_TOKEN: 'refreshing-token',
    REFRESH_TOKEN_FAILED: 'refresh-token-failed',
    REGISTER_AWAIT_RESPONSE: 'register-await-response',
    REGISTER_GOT_RESPONSE: 'register-got-response',
    REGISTER_RESPONSE_ERROR: 'register-error-response',
};

/**
 * Login error
 */
export const LoginError = {
    NONE: '',
    UNKNOWN_ERROR: 'unknown-error',
    MISSING_TOKEN_IN_RESPONSE: 'missing-token-in-response',
    MISSING_PATNR_IN_RESPONSE: 'missing-patnr-in-response',
};

export const LoginData = 'login_data';
export const PrefLang = 'pref_lang';
